import React, { Component } from 'react';
import CurrencyFormat from 'react-currency-format';
import { useCurrency } from '../../../../jsx/hooks/useCurrency';


// function MonComposant() {
//   const currency = useCurrency();

//   ...
// }

function Currency(props) {
    const currency = useCurrency();
    //console.log('===============CURRENCY=====================');
    //console.log(currency);
    //console.log('====================================');
    let value = 0
    if ( props.value !== undefined){
        value = Math.round(props.value)
    }
    let symbol = ""
    if (currency == "Euro") {
        value = Math.round(props.value * 100) / 100
        symbol = "€"
        // let value = props.round ? Math.round(props.value * 100) / 100 : props.value
    } else {
        symbol = "FCFA"

    }
    return (
        <CurrencyFormat 
            value={value} 
            displayType={'text'} 
            thousandSeparator={" "} 
            suffix={` ${symbol}`}
            // suffix={props.suffix || " FCFA"}
            prefix={props.prefix || ""}
            style={{ whiteSpace: "nowrap" }}
        />
    );
    
}

export default Currency; 
